import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ACCESS_KEY } from "../config";

const AgencyManagement = () => {
  // Lists and UI states
  const [agencies, setAgencies] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [bdAdmins, setBdAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);

  // 🚨 LIVE DEBUG STATE (सीधे स्क्रीन पर एरर देखने के लिए)
  const [liveDebugError, setLiveDebugError] = useState('');

  // Form States (Add New Agency)
  const [parentType, setParentType] = useState('bd'); 
  const [selectedParentId, setSelectedParentId] = useState('');
  const [searchUniqueId, setSearchUniqueId] = useState('');
  const [fetchedUser, setFetchedUser] = useState(null);
  const [searchMessage, setSearchMessage] = useState('');

  // Manual Inputs
  const [agencyCode, setAgencyCode] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [bankDetails, setBankDetails] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingAgencyId, setEditingAgencyId] = useState(null);

  // 1. Load All Initial Data (With Live Screen Debugging)
  const fetchPortalData = async () => {
    setLoading(true);
    setLiveDebugError(''); // पुराना एरर साफ़ करें

    // 🅰️ एडमिन्स लिस्ट लोड करो
    try {
      const adminRes = await axios.get(`https://admin.butterlive.co.in/management/getAdminUsers?start=1&limit=100`, {
        headers: { key: ACCESS_KEY || '' }
      });
      if (adminRes.data.status) {
        setAdmins(adminRes.data.data || []);
      } else {
        setLiveDebugError(prev => prev + ` | Admin API False: ${adminRes.data.message}`);
      }
    } catch (error) {
      const msg = error.response ? JSON.stringify(error.response.data) : error.message;
      setLiveDebugError(prev => prev + ` [Admin Error: ${msg}]`);
    }

    // 🅱️ बीडी एडमिन्स लिस्ट लोड करो
    try {
      const bdRes = await axios.get(`https://admin.butterlive.co.in/management/getBDAdmins?start=1&limit=100`, {
        headers: { key: ACCESS_KEY || '' }
      });
      if (bdRes.data.status) {
        setBdAdmins(bdRes.data.data || []);
      }
    } catch (error) {
      console.error("BD Fetch Error", error);
    }

    // 🆃 agencies
    try {
      const agencyRes = await axios.get(`https://admin.butterlive.co.in/management/getAgenciesForPortal?start=1&limit=50&t=${Date.now()}`, {
        headers: { key: ACCESS_KEY || '' }
      });
      if (agencyRes.data.status) setAgencies(agencyRes.data.data || []);
    } catch (error) {
      console.error("Agency Fetch Error", error);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchPortalData();
  }, []);

  const handleUserSearch = async () => {
    if (!searchUniqueId) return alert("Please enter Unique ID first");
    setSearchMessage("Searching in MongoDB...");
    setFetchedUser(null);

    try {
      const response = await axios.get(`https://admin.butterlive.co.in/management/search-device-user?uniqueId=${searchUniqueId}`, {
        headers: { key: ACCESS_KEY }
      });
      if (response.data.status) {
        setFetchedUser(response.data.data);
        setName(response.data.data.name);
        setSearchMessage("");
      } else {
        setSearchMessage("User not found in MongoDB!");
      }
    } catch (error) {
      setSearchMessage("Error verifying user");
    }
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (!selectedParentId) return alert("Please select a Parent first!");
    if (!fetchedUser) return alert("Please verify Unique ID first!");

    try {
      const response = await axios.post(`https://admin.butterlive.co.in/management/addAgency`, {
        uniqueId: parseInt(searchUniqueId),
        agencyCode: parseInt(agencyCode),
        name: name.trim(),
        phone: phone.trim(),
        email: email.trim(),
        bankDetails: bankDetails.trim(),
        parentType: parentType,
        parentId: selectedParentId
      }, {
        headers: { key: ACCESS_KEY }
      });

      if (response.data.status) {
        alert("Agency Created Successfully!");
        setShowAddModal(false);
        clearForm();
        fetchPortalData();
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      alert("Error saving agency");
    }
  };

  const clearForm = () => {
    setParentType('bd');
    setSelectedParentId('');
    setSearchUniqueId('');
    setFetchedUser(null);
    setAgencyCode('');
    setName('');
    setPhone('');
    setEmail('');
    setBankDetails('');
    setSearchMessage('');
  };

// 🔄 एजेंसी का स्टेटस एक्टिव/इनएक्टिव टॉगल करने के लिए
  const handleToggleStatus = async (id) => {
    if (!id) return alert("Agency ID missing!");
    if (!window.confirm("Are you sure you want to change this agency's status?")) return;

    try {
      const response = await axios.post(`https://admin.butterlive.co.in/management/toggleAgencyStatus`, { id }, {
        headers: { key: ACCESS_KEY }
      });

      if (response.data.status) {
        alert(response.data.message);
        fetchPortalData(); // स्टेटस बदलने के बाद लिस्ट को दोबारा लोड करें
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Toggle Status Error:", error);
      alert("Error updating agency status");
    }
  };

// 🔓 एडिट पॉपअप खोलने और उसमें पुराना डेटा भरने के लिए
  const handleOpenEditModal = (ag) => {
    setEditingAgencyId(ag._id);
    setName(ag.name);
    setPhone(ag.phone || '');
    setBankDetails(ag.bankDetails || '');
    setParentType(ag.parentType === "BD Admin" ? "bd" : "admin");
    setSelectedParentId(''); // नया पैरेंट लिस्ट से चुनने के लिए खाली रखेंगे
    setShowEditModal(true);
  };

  // 💾 एडिट की हुई डिटेल्स और नया पैरेंट बैकएंड पर सेव करने के लिए
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!selectedParentId) return alert("Please select a Parent to assign this agency!");

    try {
      const response = await axios.post(`https://admin.butterlive.co.in/management/updateAgencyDetails`, {
        id: editingAgencyId,
        name: name.trim(),
        phone: phone.trim(),
        bankDetails: bankDetails.trim(),
        parentType: parentType,
        parentId: selectedParentId
      }, {
        headers: { key: ACCESS_KEY }
      });

      if (response.data.status) {
        alert("Agency Details & Parent Updated Successfully!");
        setShowEditModal(false);
        clearForm();
        fetchPortalData(); // लिस्ट को रीलोड करें
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Edit Agency Error:", error);
      alert("Error updating agency details");
    }
  };


  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Agency Management</h1>
      </div>

      {/* 🚨 LIVE SCREEN DEBUGGER BOX */}
      {liveDebugError && (
        <div style={{ background: '#7f1d1d', color: '#fca5a5', padding: '12px', borderRadius: '8px', marginBottom: '15px', fontSize: '13px', border: '1px solid #ef4444' }}>
          <strong>LIVE NETWORK TRACKER:</strong> {liveDebugError}
        </div>
      )}

      <div className="top-bar">
        <input type="text" placeholder="Search Agency Code..." className="search-box" />
        <button onClick={() => setShowAddModal(true)} className="ban-btn ban-btn-unban" style={{ height: '40px', padding: '0 25px' }}>
          + New Agency
        </button>
      </div>

      <div className="table-card">
        <table width="100%" cellPadding="12">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Photo</th>
              <th>Agency Name</th>
              <th>Agency Code</th>
              <th>Unique ID</th>
              <th>Parent Type</th>
              <th>Mapped Parent</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" className="no-data">Loading...</td></tr>
            ) : agencies.length === 0 ? (
              <tr><td colSpan="8" className="no-data">No Agency found. Loaded Admins: {admins.length}</td></tr>
            ) : (
              agencies.map((ag, index) => (
                <tr key={ag._id || index}>
                  <td>{index + 1}</td>
                  <td><img src={ag.image || "https://placehold.co/50"} alt="" className="user-avatar" /></td>
                  <td>{ag.name}</td>
                  <td style={{ color: '#ff4d94', fontWeight: 'bold' }}>{ag.agencyCode}</td>
                  <td>{ag.uniqueId}</td>
                  <td>{ag.parentType}</td>
                  <td>{ag.parentName} ({ag.parentCode})</td>
           
<td>
  <button 
    onClick={() => handleToggleStatus(ag._id)} 
    className={`ban-btn ${ag.isActive ? "ban-btn-unban" : "ban-btn-active"}`} 
    style={{ cursor: 'pointer', padding: '5px 12px', fontSize: '12px', height: 'auto', borderRadius: '6px' }}
  >
    {ag.isActive ? "Active" : "Inactive"}
  </button>
</td>

<td>
  <button 
    onClick={() => handleOpenEditModal(ag)} 
    className="ban-btn" 
    style={{ background: '#3b82f6', cursor: 'pointer', padding: '5px 12px', fontSize: '12px', height: 'auto', borderRadius: '6px' }}
  >
    Edit
  </button>
</td>


                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal-box" style={{ width: '450px', maxHeight: '90vh', overflowY: 'auto' }}>
            <h3 style={{ margin: '0 0 20px 0', color: '#fff' }}>Create New Agency</h3>
            
            <div style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Agency Belongs To</label>
              <div style={{ display: 'flex', gap: '15px' }}>
                <label style={{ color: '#fff', fontSize: '14px', cursor: 'pointer' }}>
                  <input type="radio" name="parentType" value="bd" checked={parentType === 'bd'} onChange={() => { setParentType('bd'); setSelectedParentId(''); }} style={{ marginRight: '5px' }} />
                  BD Admin ({bdAdmins.length})
                </label>
                <label style={{ color: '#fff', fontSize: '14px', cursor: 'pointer' }}>
                  <input type="radio" name="parentType" value="admin" checked={parentType === 'admin'} onChange={() => { setParentType('admin'); setSelectedParentId(''); }} style={{ marginRight: '5px' }} />
                  Admin ({admins.length})
                </label>
              </div>
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Select Specific Parent</label>
              <select value={selectedParentId} onChange={(e) => setSelectedParentId(e.target.value)} style={{ width: '100%', padding: '10px', background: '#0f172a', color: 'white', border: '1px solid #374151', borderRadius: '8px' }}>
                <option value="">-- Choose {parentType === 'bd' ? 'BD Admin' : 'Admin'} --</option>
                {parentType === 'bd' ? (
                  bdAdmins.map(bd => <option key={bd._id} value={bd._id}>{bd.name} ({bd.codeNo})</option>)
                ) : (
                  admins.map(admin => <option key={admin._id} value={admin._id}>{admin.name} ({admin.codeNo})</option>)
                )}
              </select>
            </div>

            <div style={{ marginBottom: '15px', background: '#0f172a', padding: '15px', borderRadius: '8px', border: '1px solid #1f2937' }}>
              <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Verify User (Unique ID)</label>
              <div style={{ display: 'flex', gap: '10px' }}>
                <input type="number" placeholder="Enter User Unique ID" value={searchUniqueId} onChange={(e) => setSearchUniqueId(e.target.value)} style={{ flex: 1, padding: '10px', background: '#111827', color: 'white', border: '1px solid #374151', borderRadius: '6px' }} />
                <button type="button" onClick={handleUserSearch} className="ban-btn ban-btn-active" style={{ background: '#4f46e5' }}>Verify</button>
              </div>
              {searchMessage && <p style={{ fontSize: '12px', color: '#ef4444', margin: '5px 0 0 0' }}>{searchMessage}</p>}
              {fetchedUser && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '12px', background: '#111827', padding: '10px', borderRadius: '6px' }}>
                  <img src={fetchedUser.image || "https://placehold.co/40"} alt="" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#22c55e' }}>✔ User Verified</div>
                    <div style={{ fontSize: '13px', color: '#fff' }}>{fetchedUser.name}</div>
                  </div>
                </div>
              )}
            </div>

            <form onSubmit={handleCreateSubmit}>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Agency Code</label>
                <input type="number" value={agencyCode} onChange={(e) => setAgencyCode(e.target.value)} style={{ width: '100%', padding: '10px', background: '#0f172a', color: 'white', border: '1px solid #374151', borderRadius: '8px' }} />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Agency Name</label>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} style={{ width: '100%', padding: '10px', background: '#0f172a', color: 'white', border: '1px solid #374151', borderRadius: '8px' }} />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Phone Number</label>
                <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} style={{ width: '100%', padding: '10px', background: '#0f172a', color: 'white', border: '1px solid #374151', borderRadius: '8px' }} />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Email Address</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} style={{ width: '100%', padding: '10px', background: '#0f172a', color: 'white', border: '1px solid #374151', borderRadius: '8px' }} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Bank Details</label>
                <input type="text" value={bankDetails} onChange={(e) => setBankDetails(e.target.value)} style={{ width: '100%', padding: '10px', background: '#0f172a', color: 'white', border: '1px solid #374151', borderRadius: '8px' }} />
              </div>
              
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button type="button" onClick={() => setShowAddModal(false)} style={{ background: '#374151', border: '1px solid #4b5563' }}>Cancel</button>
                <button type="submit" className="ban-btn ban-btn-unban">Save Agency</button>
              </div>
            </form>
          </div>
        </div>
      )}

{/* 🎬 AGENCY EDIT & PARENT SHIFT MODAL */}
      {showEditModal && (
        <div className="modal-overlay">
          <div className="modal-box" style={{ width: '450px', maxHeight: '90vh', overflowY: 'auto' }}>
            <h3 style={{ margin: '0 0 20px 0', color: '#fff' }}>Edit Agency & Re-assign Parent</h3>

            <div style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Shift Agency To</label>
              <div style={{ display: 'flex', gap: '15px' }}>
                <label style={{ color: '#fff', fontSize: '14px', cursor: 'pointer' }}>
                  <input type="radio" name="editParentType" value="bd" checked={parentType === 'bd'} onChange={() => { setParentType('bd'); setSelectedParentId(''); }} style={{ marginRight: '5px' }} />
                  BD Admin ({bdAdmins.length})
                </label>
                <label style={{ color: '#fff', fontSize: '14px', cursor: 'pointer' }}>
                  <input type="radio" name="editParentType" value="admin" checked={parentType === 'admin'} onChange={() => { setParentType('admin'); setSelectedParentId(''); }} style={{ marginRight: '5px' }} />
                  Admin ({admins.length})
                </label>
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Select New Parent (Fraud Protection)</label>
              <select value={selectedParentId} onChange={(e) => setSelectedParentId(e.target.value)} style={{ width: '100%', padding: '10px', background: '#0f172a', color: 'white', border: '1px solid #374151', borderRadius: '8px' }}>
                <option value="">-- Choose New {parentType === 'bd' ? 'BD Admin' : 'Admin'} --</option>
                {parentType === 'bd' ? (
                  bdAdmins.map(bd => <option key={bd._id} value={bd._id}>{bd.name} ({bd.codeNo})</option>)
                ) : (
                  admins.map(admin => <option key={admin._id} value={admin._id}>{admin.name} ({admin.codeNo})</option>)
                )}
              </select>
            </div>

            <form onSubmit={handleEditSubmit}>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Agency Name</label>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} style={{ width: '100%', padding: '10px', background: '#0f172a', color: 'white', border: '1px solid #374151', borderRadius: '8px' }} />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Phone Number</label>
                <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} style={{ width: '100%', padding: '10px', background: '#0f172a', color: 'white', border: '1px solid #374151', borderRadius: '8px' }} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '13px', color: '#9ca3af', marginBottom: '5px' }}>Bank Details</label>
                <input type="text" value={bankDetails} onChange={(e) => setBankDetails(e.target.value)} style={{ width: '100%', padding: '10px', background: '#0f172a', color: 'white', border: '1px solid #374151', borderRadius: '8px' }} />
              </div>

              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button type="button" onClick={() => { setShowEditModal(false); clearForm(); }} style={{ background: '#374151', border: '1px solid #4b5563' }}>Cancel</button>
                <button type="submit" className="ban-btn ban-btn-unban" style={{ background: '#22c55e' }}>Update Details</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgencyManagement;
